export default __webpack_public_path__ + "static/log-axis-1ec2e88f5e57a53a6a61ffbd0fc9c499.png";